function SubContainer(props) {
    return (
        <div className="border rounded p-4 bg-light mt-3">
            {props.children}
        </div>
    );
}

export default SubContainer;